import { useState } from 'react';
import { Card } from 'react-bootstrap';

export function ExploreCard({ title, subtitle, imageUrl, onClick }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card
      as="article"
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: 'relative',
        borderRadius: 18,
        overflow: 'hidden',
        background: 'var(--theme-surface, #f8f9fa)',
        border: 'none',
        boxShadow: isHovered
          ? '0 16px 32px rgba(0, 0, 0, 0.2)'
          : '0 10px 24px rgba(0, 0, 0, 0.14)',
        minHeight: 'clamp(200px, 40vw, 280px)',
        width: '100%',
        transform: isHovered ? 'translateY(-4px) scale(1.01)' : 'translateY(0) scale(1)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        cursor: 'pointer',
      }}
    >
      {/* Background Image Layer */}
      <Card.Img
        as="div"
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transform: 'scale(1.02)',
        }}
        role="img"
        aria-label={title}
      />

      {/* Gradient Overlay */}
      <Card.ImgOverlay
        as="div"
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.42) 55%, rgba(0,0,0,0.62) 100%)',
          padding: 0,
        }}
      />

      {/* Text Content */}
      <Card.Body
        style={{
          position: 'absolute',
          left: 'clamp(12px, 3vw, 18px)',
          right: 'clamp(12px, 3vw, 18px)',
          bottom: 'clamp(12px, 3vw, 18px)',
          padding: 0,
          color: '#fff',
          zIndex: 1,
        }}
      >
        <Card.Subtitle
          as="div"
          style={{
            fontSize: 'clamp(11px, 2.5vw, 13px)',
            fontWeight: 600,
            opacity: 0.88,
            marginBottom: 6,
            color: '#fff',
          }}
        >
          {subtitle}
        </Card.Subtitle>
        <Card.Title
          as="div"
          style={{
            fontSize: 'clamp(18px, 4vw, 22px)',
            lineHeight: 1.15,
            fontWeight: 800,
            textShadow: '0 2px 10px rgba(0, 0, 0, 0.35)',
            color: '#fff',
            marginBottom: 0,
          }}
        >
          {title}
        </Card.Title>
      </Card.Body>
    </Card>
  );
}

